import {
  clearSdAuthSession,
  hasRefreshToken,
  isValidAccessToken,
  assertSecureAuthStorage,
} from "@sd/lib/sdAuthSession";
import { Navigate, Outlet, useLocation } from "react-router-dom";

/** SD protected route — valid token required, else redirect to login */
const SDProtectedRoute = () => {
  const location = useLocation();
  // An expired access token alone must NOT log the user out: as long as a
  // refresh token exists, the axios interceptor / AuthProvider refreshes the
  // access token in the background. Redirecting here on a momentarily expired
  // access token unmounts the whole app and wipes any in-progress ticket form.
  const loggedIn = isValidAccessToken() || hasRefreshToken();

  if (!loggedIn || !assertSecureAuthStorage()) {
    clearSdAuthSession();
    return <Navigate to="/sd/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default SDProtectedRoute;
